import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export const MIN_PASSWORD = 10;

export function ChangePasswordDialog({ open, onOpenChange }) {
  const { changePassword } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setF({ current: "", next: "", confirm: "" }); setError(""); } }, [open]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < MIN_PASSWORD) return setError(`Le nouveau mot de passe doit contenir au moins ${MIN_PASSWORD} caractères.`);
    if (f.next !== f.confirm) return setError("La confirmation ne correspond pas.");
    setBusy(true);
    try {
      await changePassword(f.current, f.next);
      toast.success("Mot de passe modifié. Les autres sessions ont été déconnectées.");
      onOpenChange(false);
    } catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl uppercase">Changer mon mot de passe</DialogTitle>
          <DialogDescription>Au moins {MIN_PASSWORD} caractères.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>Mot de passe actuel</Label><Input type="password" required value={f.current} onChange={set("current")} className="h-12" data-testid="current-password-input" /></div>
          <div className="space-y-1.5"><Label>Nouveau mot de passe</Label><Input type="password" required value={f.next} onChange={set("next")} className="h-12" data-testid="new-password-input" /></div>
          <div className="space-y-1.5"><Label>Confirmer</Label><Input type="password" required value={f.confirm} onChange={set("confirm")} className="h-12" data-testid="confirm-password-input" /></div>
          {error && <div className="rounded border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700" data-testid="change-password-error">{error}</div>}
          <DialogFooter className="gap-2">
            <Button type="button" variant="outline" className="h-12" onClick={() => onOpenChange(false)}>Annuler</Button>
            <Button type="submit" className="h-12" disabled={busy} data-testid="change-password-submit">Enregistrer</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
